import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

import 'moment/locale/pt-br';

// Service
import { CockpitService } from '../../service/cockpit/cockpit.service';

@Component({
	selector: 'app-cockpit',
	templateUrl: './cockpit.component.html',
	providers: [
		CockpitService,
		HttpModule
	]
})
export class CockpitComponent implements OnInit {

	public myEconomicGroups: any[] = [];
	public salesOrderFollow: any[] = [];

	public orderby: string = "ClienteNome";
	public sort: string = "asc";

	public orderbyEconomicGroup:string ="GrupoCodigo";
	public sortEconomicGroup:string = "asc";
	
	public loadFollows: boolean = false;
	public userName: string = "";
	public permissoes: any[] = [];
	public anyCockpitViewPermission: boolean = false;

	constructor(private CockpitService: CockpitService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		if(this.permissoes['Cockpit_GrupoEconomico_Visualizar'])
		  this.getEconomicGroup();
		if(this.permissoes['Cockpit_OrdemVenda_Visualizar'])
		  this.getSalesOrderFollow();
		this.userName = localStorage.getItem('yara.userName');

		this.anyCockpitViewPermission = this.getAnyCockpitViewPermission();
	}

	getAnyCockpitViewPermission() : boolean {
		return (this.permissoes['Cockpit_PropostaLC_Visualizar'] != null
		|| this.permissoes['Cockpit_AlcadaComercial_Visualizar'] != null
		|| this.permissoes['Cockpit_Abono_Visualizar'] != null
		|| this.permissoes['Cockpit_Prorrogacao_Visualizar'] != null
		|| this.permissoes['Cockpit_OrdemVenda_Visualizar'] != null
		||this.permissoes['Cockpit_GrupoEconomico_Visualizar'] != null); 
	}

	getSalesOrderFollow() {
		this.CockpitService.getSalesOrderFollow(this.orderby, this.sort).subscribe(result => {
			if (result.Success) {
				this.salesOrderFollow = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getEconomicGroup() {
		this.CockpitService.getEconomicGroups(
			this.orderbyEconomicGroup,
			this.sortEconomicGroup,).subscribe(result => {
				if (result.Success) {
					this.myEconomicGroups = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}

			}, error => {
				console.log(error);

			});
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getSalesOrderFollow();
	}

	setEconomicGroup(orderby) {
		if (this.orderbyEconomicGroup != orderby) {
			this.sortEconomicGroup = "asc";
		} else {
			this.sortEconomicGroup = this.sortEconomicGroup == "asc" ? "desc" : "asc";
		}
		this.orderbyEconomicGroup = this.orderbyEconomicGroup != orderby ? orderby : this.orderbyEconomicGroup;
		this.getEconomicGroup();
	}

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/cockpit.component.ts